// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActionsDropdownController from "./actions_dropdown_controller"
application.register("actions-dropdown", ActionsDropdownController)

import FrameModalController from "./frame_modal_controller"
application.register("frame-modal", FrameModalController)

import CheckboxToolbarController from "./checkbox_toolbar_controller"
application.register("checkbox-toolbar", CheckboxToolbarController)

import GanttChartController from "./gantt_chart_controller"
application.register("gantt-chart", GanttChartController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import ApplicationImportController from "./application_import_controller"
application.register("application-import", ApplicationImportController)

import ProjectImportController from "./project_import_controller"
application.register("project-import", ProjectImportController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HotkeySubmitController from "./hotkey_submit_controller"
application.register("hotkey-submit", HotkeySubmitController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import MarkdownEditorController from "./markdown_editor_controller"
application.register("markdown-editor", MarkdownEditorController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PersonPickerController from "./person_picker_controller"
application.register("person-picker", PersonPickerController)

import PersonFieldPickerController from "./person_field_picker_controller"
application.register("person-field-picker", PersonFieldPickerController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import SectionSpyController from "./section_spy_controller"
application.register("section-spy", SectionSpyController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SplitPanelController from "./split_panel_controller"
application.register("split-panel", SplitPanelController)

import SupportChatScrollController from "./support_chat_scroll_controller"
application.register("support-chat-scroll", SupportChatScrollController)

import SupportWidgetController from "./support_widget_controller"
application.register("support-widget", SupportWidgetController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TagInputController from "./tag_input_controller"
application.register("tag-input", TagInputController)

import ViewToggleController from "./view_toggle_controller"
application.register("view-toggle", ViewToggleController)
